import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconAutoAwesomeSvg } from "./IconAutoAwesomeSvg.mjs";
const IconAutoAwesome = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconAutoAwesomeSvg, ...iconProps });
};
export {
  IconAutoAwesome
};
